// extracted by mini-css-extract-plugin
export default {"form":"Form_form__Jl6hT","username":"Form_username__ymUgJ","password":"Form_password__FQGlh","button":"Form_button__KdV7+"};